module.exports = {
      id: "icon-video-usage",
      viewBox: "0 0 63.3 63.3",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#icon-video",
      toString: function () {
        return this.url;
      }
    }